<template lang="html">
  <section class="m-builer">
    <img
      ref="icon"
      class="img"
      :src="src"
      :alt="label"
      draggable
      @dragstart="startDrag($event)"
      @dragend="endDrag($event)"
    />
    <span>{{ message }}</span>
  </section>
</template>

<script lang="js">
  import utils from "@/utils";
  import { DISPLAY_ELEMENT_MESSAGE_KEY } from "@/static/global-variables";
  import { IMAGES } from "@/views/drag-drop-pages/static/draggable";
  import dragAndDrop from "@/views/drag-drop-pages/components/utils/dragAndDrop";

  export default  {
    name: "create-component",
    props: {
      icon: {
        type: String
      },
      label: {
        type: String
      },
      messageKey: {
        type: String
      },
      modal: {
        type: String
      },
      dropEffect: {
        type: String,
        default: dragAndDrop.DROP_EFFECT.MOVE
      },
      props: {}
    },
    computed: {
      message() {
        if (this.messageKey === DISPLAY_ELEMENT_MESSAGE_KEY.METRIC_HIGHLIGHT
          || this.messageKey === DISPLAY_ELEMENT_MESSAGE_KEY.DROPDOWN
          || this.messageKey === DISPLAY_ELEMENT_MESSAGE_KEY.DATE_PICKER) {
          return this.$t(this.messageKey);
        }
        return utils.translatedExpressionLabel({messageKey: this.messageKey}).label;
      }
    },
    mounted () {
      this.src = IMAGES[this.icon];
    },
    data () {
      return {
        src: ""
      }
    },
    methods: {
      startDrag(ev) {
        this.$refs.icon.classList.add("m-drag_start");
        const obj = {
          ev: ev,
          data: {
            modal: dragAndDrop.getBuilderName(this.modal),
            dropEffect: this.dropEffect,
            props: this.props
          }
        };
        /**
         * Triggers when model value changes
         */
        const EVENT = "drag-start";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, obj);
        }
      },
      endDrag(ev) {
        this.$refs.icon.classList.remove("m-drag_start");
        const obj = {
          ev: ev,
          data: {
            modal: this.modal,
            dropEffect: this.dropEffect,
            props: this.props
          }
        };
        /**
         * Triggers when model value changes
         */
        const EVENT = "drag-end";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          this.$emit(EVENT, obj);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .m-builer {
    display: flex;
    flex-direction: column;
    width: 60px;
    text-align: center;
    font-size: 0.6rem;
    cursor: move;
  }
  .img {
    height: 45px;
    width: 60px;
  }
</style>
